angular.module('zc.projects')

.directive 'projectPageTypes', ($translate, PageType, $timeout) ->
  directive =
    restrict: "E"
    scope: {
      requiredPageTypes: "="
      pageTypes: "="
      pageTypeOptions: "="
      matchTypes: "="
      devices: "="
      currentProject: "="
    }
    template: """
  <section>

    <table class="table table-bordered table-hover pagetype_box">
      <thead>
        <tr>
          <th>#{$translate.instant('projects.directives.projects.projectPageTypes.device')}</th>
          <th>#{$translate.instant('projects.directives.projects.projectPageTypes.setting')}</th>
          <th>#{$translate.instant('projects.directives.projects.projectPageTypes.device')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="pageType in pageTypes">
          <form name="page_type_{{pageType.id}}">
          <td class="col-xs-2">
            <select class="form-control" ng-model="pageType.required_device" ng-options="pt.value as pt.name for pt in devices"></select>
          </td>
          <td class="col-xs-3">
             <select class="form-control" ng-model="pageType.page_type" ng-options="pt.value as pt.name for pt in pageTypeOptions"></select>

            <select class="form-control" ng-model="pageType.match_type" ng-options="pt.value as pt.name for pt in matchTypes" ng-change="check(pageType)"></select>
          </td>
          <td class="col-xs-4">

            <div ng-if="pageType.match_type != 'full'">
              <input type="text" class="form-control" style="font-size: smaller" ng-model="pageType.sample_url" ng-change="check(pageType)" placeholder="#{$translate.instant('projects.directives.projects.projectPageTypes.exampleUrl')}"/>
            </div>
            <div ng-if="pageType.match_type == 'full'">
              <input type="text" class="form-control" style="font-size: smaller" ng-model="pageType.match_pattern" ng-disabled="true"placeholder="#{$translate.instant('projects.directives.projects.projectPageTypes.exampleUrl')}"/>
            </div>
             <input type="text" class="form-control" style="font-size: smaller" ng-model="pageType.match_pattern" ng-change="check(pageType)" placeholder="#{$translate.instant('projects.directives.projects.projectPageTypes.pattern')}"/>
              #{$translate.instant('projects.directives.projects.projectPageTypes.regexMatch')}
              <span ng-show="pageType.isOk" class="label label-success">#{$translate.instant('projects.directives.projects.projectPageTypes.ok')}</span>
              <span ng-hide="pageType.isOk" class="label label-danger">#{$translate.instant('projects.directives.projects.projectPageTypes.not')}</span>
          </td>

          <td class="col-xs-2">
              <button type="button" class="close pull-right" aria-hidden="true" ng-click="removePageType(pageType)">×</button>
            <div class="btn-group-vertical">
              <button type="button" class="btn btn-primary save" aria-hidden="true" ng-click="updatePageType(pageType)">#{$translate.instant('projects.directives.projects.projectPageTypes.save')}</button>
              <button type="button" class="btn btn-default reset" aria-hidden="true" ng-click="resetPageType(pageType)">#{$translate.instant('projects.directives.projects.projectPageTypes.reset')}</button>
            </div>
          </td>
          </form>
        </tr>

        <tr>
          <td colspan="5">
            <button class="btn btn-large btn-primary col-sm-12" ng-click="addPageType()">#{$translate.instant('projects.directives.projects.projectPageTypes.add')}</button>
          </td>
        </tr>
      </tbody>
    </table>

  </section>
    """

    link: (scope, element, attrs) ->

    controller: ($scope) ->
      $scope.check = (pageType) ->
        if pageType.match_type == "full"
          # No need to check in this case, because full means that
          # sample_url == match_pattern
          pageType.isOk = true
        else if pageType.match_type == "prefix"
          if pageType.sample_url && pageType.sample_url.indexOf(pageType.match_pattern) == 0
            pageType.isOk = true
          else
            pageType.isOk = false
        else if pageType.match_type == "regexp"
          regexp = new RegExp(pageType.match_pattern)
          if pageType.sample_url && regexp.test(pageType.sample_url)
            pageType.isOk = true
          else
            pageType.isOk = false

      $scope.removePageType = (pageType) ->
        PageType.destroy(pageType)
        .then (res) ->
          $scope.pageTypes.splice($scope.pageTypes.indexOf(pageType), 1)

      $scope.addPageType = () ->
        PageType.create($scope.currentProject.id)
        .then (res) ->
          $scope.pageTypes.push(res)

      $scope.resetPageType = (pageType) ->
        PageType.update({ projectId: pageType.project_id, id: pageType.id}, {page_type: {is_found_pc: false, is_found_sp: false}})

      $scope.updatePageType = (pageType) ->
        PageType.update({ projectId: pageType.project_id, id: pageType.id}, {page_type: pageType})

      $scope.$watchCollection 'pageTypes', () ->
        for pt in $scope.pageTypes
          $scope.check(pt)

  directive



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/directives/projects/project_page_types.js.coffee